//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './OrderListClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetOrderListQueryParameters = {
  orderedFrom?: Date | null | undefined ;
  orderedTo?: Date | null | undefined ;
  deliveryDateFrom?: Date | null | undefined ;
  deliveryDateTo?: Date | null | undefined ;
  order?: string | null | undefined ;
  reference?: string | null | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export function getUrl(orderedFrom?: Date | null | undefined, orderedTo?: Date | null | undefined, deliveryDateFrom?: Date | null | undefined, deliveryDateTo?: Date | null | undefined, order?: string | null | undefined, reference?: string | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/order-list?";
if (orderedFrom !== undefined && orderedFrom !== null)
    url_ += "OrderedFrom=" + encodeURIComponent(orderedFrom ? "" + Types.formatDate(orderedFrom) : "") + "&";
if (orderedTo !== undefined && orderedTo !== null)
    url_ += "OrderedTo=" + encodeURIComponent(orderedTo ? "" + Types.formatDate(orderedTo) : "") + "&";
if (deliveryDateFrom !== undefined && deliveryDateFrom !== null)
    url_ += "DeliveryDateFrom=" + encodeURIComponent(deliveryDateFrom ? "" + Types.formatDate(deliveryDateFrom) : "") + "&";
if (deliveryDateTo !== undefined && deliveryDateTo !== null)
    url_ += "DeliveryDateTo=" + encodeURIComponent(deliveryDateTo ? "" + Types.formatDate(deliveryDateTo) : "") + "&";
if (order !== undefined && order !== null)
    url_ += "Order=" + encodeURIComponent("" + order) + "&";
if (reference !== undefined && reference !== null)
    url_ += "Reference=" + encodeURIComponent("" + reference) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.ResponseOrderListDto, unknown, Types.ResponseOrderListDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ResponseOrderListDto, unknown, Types.ResponseOrderListDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(dto: GetOrderListQueryParameters): QueryKey;
export function getQueryKey(orderedFrom?: Date | null | undefined, orderedTo?: Date | null | undefined, deliveryDateFrom?: Date | null | undefined, deliveryDateTo?: Date | null | undefined, order?: string | null | undefined, reference?: string | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { orderedFrom, orderedTo, deliveryDateFrom, deliveryDateTo, order, reference, offset, limit, sortBy, sortOrder,  } = params[0] as GetOrderListQueryParameters;

    return trimArrayEnd([
        'OrderListClient',
        'get',
        orderedFrom as any,
        orderedTo as any,
        deliveryDateFrom as any,
        deliveryDateTo as any,
        order as any,
        reference as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'OrderListClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as Date | null | undefined,       context.queryKey[3] as Date | null | undefined,       context.queryKey[4] as Date | null | undefined,       context.queryKey[5] as Date | null | undefined,       context.queryKey[6] as string | null | undefined,       context.queryKey[7] as string | null | undefined,       context.queryKey[8] as number | null | undefined,       context.queryKey[9] as number | null | undefined,       context.queryKey[10] as string | null | undefined,       context.queryKey[11] as Types.SortOrder | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.ResponseOrderListDto, TError = unknown>(dto: GetOrderListQueryParameters, options?: Omit<UseQueryOptions<Types.ResponseOrderListDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets data.
 * @param orderedFrom (optional) 
 * @param orderedTo (optional) 
 * @param deliveryDateFrom (optional) 
 * @param deliveryDateTo (optional) 
 * @param order (optional) 
 * @param reference (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useGetQuery<TSelectData = Types.ResponseOrderListDto, TError = unknown>(orderedFrom?: Date | null | undefined, orderedTo?: Date | null | undefined, deliveryDateFrom?: Date | null | undefined, deliveryDateTo?: Date | null | undefined, order?: string | null | undefined, reference?: string | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.ResponseOrderListDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.ResponseOrderListDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ResponseOrderListDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let orderedFrom: any = undefined;
  let orderedTo: any = undefined;
  let deliveryDateFrom: any = undefined;
  let deliveryDateTo: any = undefined;
  let order: any = undefined;
  let reference: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ orderedFrom, orderedTo, deliveryDateFrom, deliveryDateTo, order, reference, offset, limit, sortBy, sortOrder,  } = params[0] as GetOrderListQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [orderedFrom, orderedTo, deliveryDateFrom, deliveryDateTo, order, reference, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ResponseOrderListDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(orderedFrom, orderedTo, deliveryDateFrom, deliveryDateTo, order, reference, offset, limit, sortBy, sortOrder),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.ResponseOrderListDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets data.
 * @param orderedFrom (optional) 
 * @param orderedTo (optional) 
 * @param deliveryDateFrom (optional) 
 * @param deliveryDateTo (optional) 
 * @param order (optional) 
 * @param reference (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.ResponseOrderListDto | undefined) => Types.ResponseOrderListDto, orderedFrom?: Date | null | undefined, orderedTo?: Date | null | undefined, deliveryDateFrom?: Date | null | undefined, deliveryDateTo?: Date | null | undefined, order?: string | null | undefined, reference?: string | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(getQueryKey(orderedFrom, orderedTo, deliveryDateFrom, deliveryDateTo, order, reference, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Gets data.
 * @param orderedFrom (optional) 
 * @param orderedTo (optional) 
 * @param deliveryDateFrom (optional) 
 * @param deliveryDateTo (optional) 
 * @param order (optional) 
 * @param reference (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ResponseOrderListDto | undefined) => Types.ResponseOrderListDto) {
  queryClient.setQueryData(queryKey, updater);
}